import { create } from "zustand";

const settings = window.post_template?.checkout_v4_additional_upsell || {};

// The upsell is pre-checked by default (customers can opt out); admins can
// flip the default through the "Selected By Default" ACF toggle.
const enabledByDefault =
  !!settings.checkout_v4_additional_upsell_show &&
  (settings.checkout_v4_additional_upsell_default_checked ?? true) !== false;

export const useAdditionalUpsell = create((set) => ({
  additionalUpsellEnabled: enabledByDefault,
  setAdditionalUpsellEnabled: (enabled) => set({ additionalUpsellEnabled: enabled }),
}));
